<script>
import AccountConfirmationComponent from '../features/AccountConfirmationComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'AccountConfirmationView',
  components: {
        'brand-logo': BrandLogo,},
  mixins: [AccountConfirmationComponent],
};
</script>

<template>
  <div class="public-page">
    <div class="public-page__background">
      <!-- Left Branding Panel -->
      <div class="public-page__branding">
        <div class="public-page__branding-content">
          <router-link
            to="/"
            class="public-page__logo-link"
          >
            <brand-logo
              variant="light"
              size="lg"
              stacked
            />
          </router-link>
          <div class="public-page__branding-text">
            <h1>¡Bienvenido a AppMisionate!</h1>
            <p>Tu cuenta ha sido confirmada. Accede y comienza a aprender.</p>
          </div>
        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="public-page__form-panel">
        <div class="public-page__card">
          <!-- Card Header -->
          <div class="public-page__card-header">
            <div class="public-page__card-header-icon">
              <i class="uil uil-check-circle" />
            </div>
            <h2>Cuenta Confirmada</h2>
            <p>Tu cuenta ha sido verificada exitosamente</p>
          </div>

          <!-- Info -->
          <div class="public-page__info">
            <i class="uil uil-envelope-check" />
            Gracias por confirmar tu cuenta. Ahora puedes iniciar sesión y disfrutar de todos los cursos.
          </div>

          <!-- Form -->
          <el-form
            ref="formData"
            v-loading="isFormProcessing"
            :model="formData"
            :rules="rules"
            status-icon
            :label-position="'top'"
            :element-loading-text="formProcessingMessage"
            class="public-page__form"
          >
            <div class="public-page__submit">
              <el-button
                type="primary"
                size="large"
                class="public-page__submit-btn"
                :loading="isFormProcessing"
                @click="onGoToLogin('formData')"
              >
                <i class="uil uil-sign-in-alt" />
                Iniciar Sesión
              </el-button>
            </div>
          </el-form>

          <!-- Footer -->
          <div class="public-page__card-footer">
            <p>
              ¿No recibiste el correo?
              <router-link to="/registrarse">
                Regístrate aquí
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
